import { MutationOptions, useMutation } from "@apollo/client";

import { SettingsFormTemplateEditor_Shared_DeleteFormTemplateQuestionDocument } from "../mutations.generated";

export default function useSettingsFormTemplateEditor_Shared_DeleteFormTemplateQuestion(
    refetchQueries?: MutationOptions["refetchQueries"],
) {
    const [mutate, { loading, error }] = useMutation(
        SettingsFormTemplateEditor_Shared_DeleteFormTemplateQuestionDocument,
        {
            refetchQueries,
        },
    );

    const deleteFormTemplateQuestion = async (formTemplateQuestionId: string) => {
        await mutate({ variables: { input: { formTemplateQuestionId } } });
    };

    return {
        deleteFormTemplateQuestion,
        loading,
        error,
    };
}
